import {useState} from "react";
import axios from "axios";

export const useWallets = () => {
    const [wallets, setWallets] = useState<string[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error | null>(null);


    const fetchWallets = async (businessId: string) => {
        setLoading(true);
        setError(null);
        try {
            const response = await axios(
                `${process.env.REACT_APP_API_URL}wallet/businesses/${businessId}/data`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        ...(process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN && {
                            'x-fe-token': process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN,
                        }),
                    },
                }
            );

            if (response.status === 200) {
                setWallets(response?.data?.data.walletCurrencies || []);
            } else {
                throw new Error(`Failed to fetch wallets: ${response.status}`);
            }
        } catch (error: any) {
            console.error('Error fetching wallets:', error?.response?.status, error?.response?.data);
            setError(error instanceof Error ? error : new Error('An unknown error occurred'));
        } finally {
            setLoading(false);
        }
    };

    return {wallets, loading, error, fetchWallets};
};